import "./Contact.css";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";
import ClientSlider from "../../components/clientSlider/ClientSlider";
import ExploreEmployees from "../../components/exploreEmployees/ExploreEmployees";
import { BsInstagram } from "react-icons/bs";
import { FaLinkedin } from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io";
import { IoMdMail } from "react-icons/io";

const Contact = () => {
  return (
    <div className="app-container">
      <Navbar showSearch />

      <div className="contact-main">
        <div className="contact-main-content">
          <h1 data-aos="fade-right">Get in touch</h1>
        </div>
      </div>

      <ExploreEmployees
        title="Contact Channels"
        para="We prioritize your enquiries, feedback, complaints, and we hope to optimize your experience. Feel free to reach out to us via our designated channels!"
        children={
          <div className="flex-contact-container">
            <div className="flex-contact">
              <IoLogoWhatsapp
                style={{
                  fontSize: "20px",
                  marginRight: "3px",
                }}
              />

              <a
                href="https://wa.me/message/BRBHAKBVPFCWO1"
                target="_blank"
                rel="noopener noreferrer"
              >
                +234 701 1473 843
              </a>
            </div>

            <div className="flex-contact">
              <IoMdMail
                style={{
                  fontSize: "20px",
                  marginRight: "3px",
                }}
              />

              <a href="mailto:contact@freelancemedic.com" className="underline">
                contact@freelancemedic.com
              </a>
            </div>

            <div className="flex-contact">
              <BsInstagram
                style={{
                  fontSize: "20px",
                  marginRight: "3px",
                }}
              />

              <a
                href="https://www.instagram.com/freelancemedicng?igsh=bzR3eTQyb2dmZ2wx"
                target="_blank"
                rel="noopener noreferrer"
              >
                @freelancemedicng
              </a>
            </div>

            <div className="flex-contact">
              <FaLinkedin
                style={{
                  fontSize: "20px",
                  marginRight: "3px",
                }}
              />

              <a
                href="https://www.linkedin.com/company/freelancemedic"
                target="_blank"
                rel="noopener noreferrer"
              >
                freelancemedic
              </a>
            </div>
          </div>
        }
      />

      <ClientSlider />
      <Footer />
    </div>
  );
};

export default Contact;
